var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"air-row"},[_c('td',[_vm._v(_vm._s(_vm.item.url))]),_c('td',[_vm._v(_vm._s(_vm.item.metrics[0].value))]),_c('td',[_vm._v(_vm._s(_vm.item.metrics[1].value))])])}
var staticRenderFns = []

export { render, staticRenderFns }